<script>
import _ from "lodash";

export default {
  name: "SysAdminBase",
  data() {
    return {
    }
  },

  methods: {
    getField(e, selector) {
      const inp = e.target.closest('.api-box')?.querySelector(selector);
      if(!inp) return null;
      return inp;
    },
    getFieldValue(e, selector) {
      const inp = this.getField(e, selector);
      if(!inp) return null;
      return inp.value.trim();
    },
    getRoomIdValue(e) {
      return this.getFieldValue(e, '[name="roomId"]')
    },
    getRoomUrlIdValue(e) {
      return this.getFieldValue(e, '[name="roomUrlId"]')
    },
    getUserIdValue(e) {
      return this.getFieldValue(e, '[name="userId"]')
    },
    writeDescInline(e, data={}) {
      const el = this.getField(e, '.desc-inline');
      if(!el){
        console.warn('desc el is null', e)
        return;
      }
      let msg = data;
      if(typeof(data) === 'object'){
          msg = data.msg;
      }
      el.innerText = ''+msg;
      el.setAttribute('data-show', '')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>